/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginModel } from '../../models/login-model';
import { TokenDto } from '../../models/token-dto';

export interface LoginLogin$Plain$Params {
      body?: LoginModel
}

export function loginLogin$Plain(http: HttpClient, rootUrl: string, params?: LoginLogin$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenDto>> {
  const rb = new RequestBuilder(rootUrl, loginLogin$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenDto>;
    })
  );
}

loginLogin$Plain.PATH = '/api/Login';
